import React from "react";

const PrivacyPolicy = () => {
  return (
    <div className="privacy-policy" style={{ padding: "2rem", maxWidth: "800px", margin: "0 auto" }}>
      <h1>Polityka Prywatności</h1>

      <h2>1. Informacje ogólne</h2>
      <p>
        Niniejsza Polityka Prywatności określa zasady przetwarzania danych osobowych użytkowników
        korzystających z platformy do ankiet medycznych <strong>ankiety.coms.pl</strong>.
      </p>

      <h2>2. Zakres zbieranych danych</h2>
      <p>W ramach korzystania z Platformy przetwarzamy dane osobowe użytkowników, w szczególności:</p>
      <ul>
        <li>dane identyfikacyjne (np. imię, nazwisko, adres e-mail, PESEL),</li>
        <li>dane związane z udzielonymi odpowiedziami w ankietach, które mogą obejmować dane o stanie zdrowia.</li>
      </ul>

      <h2>3. Cel i podstawa przetwarzania danych</h2>
      <p>Dane osobowe przetwarzane są w celu:</p>
      <ul>
        <li>umożliwienia korzystania z Platformy i wypełniania ankiet,</li>
        <li>zarządzania kontem użytkownika (jeśli dotyczy),</li>
        <li>zapewnienia bezpieczeństwa i integralności danych,</li>
        <li>spełnienia obowiązków prawnych,</li>
        <li>ochrony roszczeń i obrony przed roszczeniami.</li>
      </ul>
      <p>Podstawy prawne przetwarzania danych:</p>
      <ul>
        <li>zgoda użytkownika (art. 6 ust. 1 lit. a oraz art. 9 ust. 2 lit. a RODO),</li>
        <li>wypełnienie obowiązków prawnych (art. 6 ust. 1 lit. c RODO),</li>
        <li>prawnie uzasadnione interesy Administratora (art. 6 ust. 1 lit. f RODO).</li>
      </ul>
      <p><strong>Udzielenie zgody na przetwarzanie danych jest dobrowolne, lecz niezbędne do korzystania z Platformy.</strong></p>

      <h2>4. Ochrona danych wrażliwych</h2>
      <p>W przypadku danych dotyczących zdrowia:</p>
      <ul>
        <li>stosujemy szczególne środki techniczne i organizacyjne zapewniające wysoki poziom ochrony danych (np. szyfrowanie, pseudonimizację),</li>
        <li>dostęp do danych mają wyłącznie upoważnione osoby.</li>
      </ul>

      <h2>5. Odbiorcy danych</h2>
      <p>Dane osobowe mogą być przekazywane:</p>
      <ul>
        <li>dostawcom usług IT, hostingowych, administracyjnych – wyłącznie na podstawie odpowiednich umów zapewniających ochronę danych,</li>
        <li>organom publicznym, jeśli wynika to z obowiązku prawnego.</li>
      </ul>
      <p>Nie udostępniamy danych osobowych osobom trzecim w celach marketingowych bez wyraźnej zgody użytkownika.</p>

      <h2>6. Przekazywanie danych poza Europejski Obszar Gospodarczy</h2>
      <p>Co do zasady, dane nie są przekazywane poza Europejski Obszar Gospodarczy (EOG). W przypadku przekazywania danych poza EOG, zapewniamy odpowiedni poziom ochrony danych zgodnie z wymaganiami RODO.</p>

      <h2>7. Okres przechowywania danych</h2>
      <p>Dane osobowe przechowujemy:</p>
      <ul>
        <li>przez okres niezbędny do realizacji celów przetwarzania,</li>
        <li>przez okres wymagany przepisami prawa,</li>
        <li>do momentu wycofania zgody na przetwarzanie danych osobowych.</li>
      </ul>
      <p>Po upływie odpowiedniego okresu dane są usuwane lub anonimizowane.</p>

      <h2>8. Prawa użytkowników</h2>
      <p>Użytkownikowi przysługują następujące prawa:</p>
      <ul>
        <li>prawo dostępu do danych,</li>
        <li>prawo do sprostowania danych,</li>
        <li>prawo do usunięcia danych („prawo do bycia zapomnianym”),</li>
        <li>prawo do ograniczenia przetwarzania,</li>
        <li>prawo do przenoszenia danych,</li>
        <li>prawo do wycofania zgody w dowolnym momencie,</li>
        <li>prawo wniesienia skargi do Prezesa Urzędu Ochrony Danych Osobowych.</li>
      </ul>
      <p>W celu realizacji swoich praw prosimy o kontakt na adres: <strong>kontakt@ankiety.coms.pl</strong>.</p>

      <h2>9. Pliki cookies</h2>
      <p>Platforma wykorzystuje pliki cookies wyłącznie w celach technicznych, niezbędnych do prawidłowego działania serwisu.<br/>
      Pliki cookies nie służą do profilowania użytkowników ani celów marketingowych.</p>
      <p>Użytkownik może w każdej chwili zarządzać ustawieniami cookies w swojej przeglądarce internetowej.</p>

      <h2>10. Zmiany Polityki Prywatności</h2>
      <p>Administrator zastrzega sobie prawo do aktualizacji niniejszej Polityki Prywatności w związku ze zmianami w prawie lub zmianami technologicznymi Platformy.</p>
    </div>
  );
};

export default PrivacyPolicy;
